module.exports = __webpack_public_path__ + "static/media/minus.b83787e8.svg";